import React from 'react'
import styled from '@emotion/styled'

const Root = styled.div`
  display: inline-block;
  border-radius: 1px;
  margin-bottom: 2px;
  padding: ${({size}) => size === 'normal' ? '4px 5px 2px 5px' : '3px 2px 1px 3px'};
  margin-right: 6px;
  background: #6eb971;
  color: white;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: center;
  font: 8px/1 raleway, sans-serif;
  font-weight: 600;
`

const GoodNovelty = ({
  isNew,
  size = 'normal'
}) => {
  if (!isNew) return null

  return <Root size={size}>
    Новинка
  </Root>
}

export default GoodNovelty
